//HDI Ticket statuses
export const HDI_TICKET_STATUS_NEW = 'NEW';
export const HDI_TICKET_STATUS_OPENED = 'OPENED';
export const HDI_TICKET_STATUS_CLOSED = 'CLOSED';
export const HDI_TICKET_STATUS_SUSPENDED = 'SUSPENDED';
export const HDI_TICKET_STATUS_ON_HOLD = 'ON_HOLD';
export const HDI_TICKET_STATUS_NEWOPENED = 'NEWOPENED';
export const HDI_TICKET_STATUS_REOPENED = 'REOPENED';
export const HDI_TICKET_STATUS_WAITING_ON_OWNER = 'WAITING_ON_OWNER';
